/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Fulfillment Inbound
 * The Selling Partner API for Fulfillment Inbound lets you create applications that create and update inbound shipments of inventory to Amazon\'s fulfillment network.
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Labeling requirements for the item. For more information about FBA labeling requirements, see the Seller Central Help for your marketplace.
 */

export const BarcodeInstruction = {
    RequiresFnskuLabel: 'RequiresFNSKULabel',
    CanUseOriginalBarcode: 'CanUseOriginalBarcode',
    MustProvideSellerSku: 'MustProvideSellerSKU',
} as const;

export type BarcodeInstruction = typeof BarcodeInstruction[keyof typeof BarcodeInstruction];



